import React from "react";
import { Box, Typography, Chip } from "@mui/material";
import BuildIcon from "@mui/icons-material/Build";
import AutoAwesomeIcon from "@mui/icons-material/AutoAwesome";

interface ComingSoonPlaceholderProps {
  toolName?: string;
  toolColor?: string;
  toolIcon?: React.ReactNode;
}

export const ComingSoonPlaceholder: React.FC<ComingSoonPlaceholderProps> = ({
  toolName = "Questo strumento",
  toolColor = "#7B1FA2",
  toolIcon,
}) => {
  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        gap: 3,
        py: 6,
        px: 4,
        maxWidth: 480,
        mx: "auto",
        textAlign: "center",
      }}
    >
      <Box
        sx={{
          width: 96,
          height: 96,
          borderRadius: "28px",
          bgcolor: toolColor + "14",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          color: toolColor,
          "& svg": { fontSize: "2.8rem" },
          position: "relative",
        }}
      >
        {toolIcon ?? <BuildIcon />}
        <Box
          sx={{
            position: "absolute",
            bottom: -6,
            right: -6,
            width: 28,
            height: 28,
            borderRadius: "50%",
            bgcolor: toolColor,
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
          }}
        >
          <AutoAwesomeIcon sx={{ fontSize: "0.9rem", color: "#fff" }} />
        </Box>
      </Box>

      <Box>
        <Typography variant="h5" sx={{ fontWeight: 700, mb: 1 }}>
          {toolName}
        </Typography>
        <Typography variant="body1" color="text.secondary" sx={{ lineHeight: 1.8 }}>
          Questo strumento è attualmente in sviluppo e sarà disponibile nelle
          prossime versioni della piattaforma.
        </Typography>
      </Box>

      <Box sx={{ display: "flex", gap: 1, flexWrap: "wrap", justifyContent: "center" }}>
        <Chip
          icon={<BuildIcon sx={{ fontSize: "0.85rem !important" }} />}
          label="In sviluppo"
          size="small"
          sx={{ bgcolor: toolColor + "14", color: toolColor, fontWeight: 600 }}
        />
        <Chip
          label="Presto disponibile"
          size="small"
          variant="outlined"
          sx={{ borderColor: toolColor + "50", color: toolColor }}
        />
      </Box>
    </Box>
  );
};
